// eslint-disable-next-line import/prefer-default-export
export const SET_SHIFT_KEY_STATUS = 'SET_SHIFT_KEY_STATUS';
